export const brandRoutes = {
  DOCS: "/docs",

  HOME: {
    ROOT: "/home",
    OVERVIEW: "/home/overview",
    KPI_DEEP_DIVE: "/home/kpi-deep-dive",
    METRICS_EXPLORER: "/home/metrics-explorer",
    LTV_COHORTS: "/home/ltv-cohorts",
    SUBSEQUENT_PURCHASES: "/home/subsequent-purchases",
    V2: "/home-v2",
    NEW_GOAL: "/home/new-goal",
  },

  BRAND_VALUE: {
    ROOT: "/brand-value",
    OVERVIEW: "/brand-value/overview",
    COHORT_ANALYSIS: "/brand-value/cohort-analysis",
  },

  BRAND_MEDIA: {
    ROOT: "/brand-media",
    PAID_OPTIMIZATION: "/brand-media/paid-optimization",
    PAID_WEIGHTS: "/brand-media/paid-weights",
    AD_DESTINATIONS: "/brand-media/ad-destinations",
  },

  ORGANIC_MEDIA: {
    ROOT: "/organic-media",
    ORGANIC_SOCIAL_POSTS: "/organic-media/organic-social-posts",
    MEDIA_MENTIONS: "/organic-media/media-mentions",
  },

  EXPERIMENTS: {
    ROOT: "/experiments",
    RESULTS: "/experiments/results",
  },

  CREATIVE_REPORTS: {
    ROOT: "/creative-reports",
    V2: "/creative-reports-v2",
    TAXONOMY: "/creative-reports/taxonomy",
  },

  MEGA_FEED: {
    ROOT: "/mega-feed",
  },

  CUSTOM_REPORTS: {
    ROOT: "/custom-reports",
    NEW: "/custom-reports/new",
    VIEW: "/custom-reports/:id",
    EDIT: "/custom-reports/:id/edit",
  },

  MARKET_SHARE: {
    ROOT: "/market-share/share-of-search",
    SHARE_OF_SEARCH: "/market-share/share-of-search",
  },

  BRAND_POSITIONING: {
    ROOT: "/brand-positioning/how-ai-sees-your-brand",
  },

  BRAND_RESEARCH: {
    ROOT: "/brand-research",
    MENTIONS_ANALYSIS: "/brand-research/mentions-analysis",
  },

  WEB_MERCHANDISING: {
    ROOT: "/web-merchandising",
    COLLECTION_FUNNEL: "/web-merchandising/collection-funnel",
    PRODUCT_PAGE_FUNNEL: "/web-merchandising/product-page-funnel",
    HOMEPAGE_FUNNEL: "/web-merchandising/homepage-funnel",
    PAGE_PATH_REPORT: "/web-merchandising/page-path-report",
    LANDING_PAGE_REPORT: "/web-merchandising/landing-page-report",
    PRODUCT_MEDIA_PNL: "/web-merchandising/product-media-pnl",
    PRE_ATC_ANALYSIS: "/web-merchandising/pre-atc-analysis",
    PAGE_DEPTH_ANALYSIS: "/web-merchandising/page-depth-analysis",
    INVENTORY_ANALYSIS: "/web-merchandising/inventory-analysis",
  },

  REVENUE: {
    ROOT: "/revenue",
    GOOGLE_ANALYTICS: "/revenue/google-analytics",
    GOOGLE_ANALYTICS_MULTI_PROPERTY: "/revenue/google-analytics-multi-property",
    SHOPIFY: "/revenue/shopify",
    SHOPIFY_ORDERS: "/revenue/shopify-orders",
    KPI: "/revenue/kpi",
  },

  WEB_ANALYTICS: {
    ROOT: "/web-analytics",
    JOURNEY_ANALYSIS: "/web-analytics/journey-analysis",
  },

  SETTINGS: {
    ROOT: "/settings",
    PROFILE: "/settings/profile",
    PASSWORD: "/settings/password",
    USERS: "/settings/users",
    COMPANY: "/settings/company",
    BRAND_EVENTS: "/settings/brand-events",
    KEY_EVENTS: "/settings/key-events",
    PIPELINE_MONITOR: "/settings/pipeline-monitor",
    API_KEYS: "/settings/api-keys",
    CLAUDE: "/settings/claude",
    BUDGET_UPDATES: "/settings/budget-updates",
    AD_BLASTER: "/settings/ad-blaster",
  },

  SETUP: {
    ROOT: "/setup",
    CONNECTORS: "/setup/connectors",
    FILE_DROP: "/setup/file-drop",
    KEYWORDS: "/setup/keywords-and-competitors",
    AUDIENCES: "/setup/audiences",
    REVENUE_SOURCE: "/setup/revenue-source",
    FINANCIAL_SETTINGS: "/setup/financial-settings",
    TAGS: "/setup/tags",
    METRIC_DICTIONARY: "/setup/metric-dictionary",
    /** Both superseded by the AUDITS section. Kept so existing links redirect instead of 404ing. */
    UTM_AUDIT: "/setup/utm-audit",
    EXCLUSIONS_AUDIT: "/setup/exclusions-audit",
  },

  AUDITS: {
    ROOT: "/audits",
    DESTINATION_URLS: "/audits/destination-urls",
    UTM: "/audits/utm",
    EXCLUSIONS: "/audits/exclusions",
  },

  CAMPAIGN_MANAGEMENT: {
    ROOT: "/campaign-management",
    CAMPAIGNS: "/campaign-management/campaigns",
    ADSETS: "/campaign-management/adsets",
    ADS: "/campaign-management/ads",
  },

  AD_FORGE: {
    ROOT: "/ad-forge",
  },

  AD_BLASTER: {
    ROOT: "/ad-blaster",
    CREATIVES: "/ad-blaster/creatives",
    ADS: "/ad-blaster/ads",
    SOCIAL_POSTS: "/ad-blaster/social-posts",
    PARTNERSHIPS: "/ad-blaster/partnerships",
    AD_FORGE: "/ad-blaster/ad-forge",
  },

  CREATIVE_MANAGEMENT: {
    ROOT: "/creative-management",
  },

  JOBS: {
    ROOT: "/jobs",
  },

  // Daily hide of competitor / spam / negative comments on Meta ad posts:
  // the report of judged comments with unhide (MD-5576).
  COMMENT_MODERATION: {
    ROOT: "/comment-moderation",
  },

  // Live Meta campaign / ad set budget editor (no Cube), behind the
  // `meta-budget-editor` flag.
  META_BUDGETS: {
    ROOT: "/meta-budgets",
  },

  // Super-admin only: cross-company recurring job schedule management.
  ADMIN_SCHEDULED_JOBS: {
    ROOT: "/admin/scheduled-jobs",
  },

  // Super-admin only: cross-company ad-blast launch tracker (audit-backed).
  ADMIN_AD_BLAST_REPORTS: {
    ROOT: "/admin/ad-blast-reports",
  },

  BRAND_AGENDA: {
    ROOT: "/brand-agenda",
  },

  CAMPAIGN_BLASTER: {
    ROOT: "/campaign-blaster",
  },

  MARKET_PREDICTION: {
    ROOT: "/market-prediction",
  },

  COMPANY_CREATE: {
    ROOT: "/company/create",
  },

  ONBOARDING: {
    CONNECT_SOURCES: "/onboarding/connect-sources",
  },

  OAUTH_CONNECTION: "/oauth-connection",
  AUTHENTICATE_CONNECTOR: "/authenticate-connector",

  SIGN_IN: "/sign-in",
  SIGN_UP: "/sign-up",
  RESET_PASSWORD: "/reset-password",
} as const

export const DEFAULT_LOGGED_ROUTE = brandRoutes.HOME.OVERVIEW
